<template>
  <div class="submital-admin-section">
    <SubmitalNavbar />

    <SubmitalHeader :submital="submital" page="admin" />

    <ContentView v-if="submital.id">
      <div class="admin-wrapper pt-4">

        <SubmitalLockCard
          :submital="submital"
          :configurable="configurable"
          class="mb-3"
        />

        <AuditEventTable ref="auditTable" :url="auditEventsUrl" />

        <b-card v-if="isSupervisor" no-body border-variant="danger">
          <div class="d-flex justify-content-between align-items-center p-3">
            <div class="d-flex align-items-center">
              <div class="delete-icon">
                <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
              </div>
              <div class="ml-3">
                <div class="fs-15 font-weight-bold">Borrar este submital</div>
                <div class="fs-13 text-muted">
                  {{ locked
                    ? 'Desbloquee el submital para poder borrarlo'
                    : 'Se registrará la acción, los cambios no se pueden revertir' }}
                </div>
              </div>
            </div>
            <Button variant="red" :disabled="locked || processing" @click="showConfirmModal = true">
              <font-awesome-icon :icon="['far', 'trash-alt']" fixed-width />
              <span class="pl-2 fs-14">Borrar</span>
            </Button>
          </div>
        </b-card>
      </div>
    </ContentView>

    <b-modal
      v-model="showConfirmModal"
      centered
      hide-header
      hide-footer
      body-class="p-0"
      content-class="border-0 bg-transparent"
    >
      <div class="bg-white text-center shadow-lg" style="border-radius: 24px; overflow: hidden;">
        <div class="d-flex justify-content-end px-3 pt-3">
          <button type="button" class="close" aria-label="Cerrar" style="font-size: 28px;" @click="showConfirmModal = false">&times;</button>
        </div>
        <div class="px-4 pb-4">
          <div class="rounded-circle d-flex align-items-center justify-content-center mx-auto mb-3" style="width: 88px; height: 88px; background-color: #fef2f2;">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" size="2x" class="text-danger" fixed-width />
          </div>
          <h5 class="font-weight-bold text-dark mb-2">¿Borrar submital {{ submital.submital_no }}?</h5>
          <p class="text-secondary mb-4">
            Se eliminará la configuración, las fotos y los documentos asociados. Esta acción no se puede deshacer.
          </p>
          <div class="d-flex justify-content-center">
            <button type="button" class="btn btn-secondary rounded-lg font-weight-bold px-4 mx-2" @click="showConfirmModal = false">
              Cancelar
            </button>
            <button type="button" class="btn btn-danger rounded-lg font-weight-bold px-4 mx-2" :disabled="processing" @click="deleteSubmital">
              {{ processing ? 'Borrando...' : 'Sí, borrar' }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Button from '../../shared/Button'
import ContentView from '../../shared/ContentView'
import AuditEventTable from '../../shared/AuditEventTable'
import SubmitalHeader from './SubmitalHeader'
import SubmitalNavbar from './SubmitalNavbar'
import SubmitalLockCard from './SubmitalLockCard'

export default {
  name: 'SubmitalAdmin',
  components: {
    Button, ContentView, AuditEventTable,
    SubmitalHeader, SubmitalNavbar, SubmitalLockCard
  },
  data () {
    return {
      id: Number(this.$route.params.id),
      processing: false,
      showConfirmModal: false
    }
  },
  computed: {
    ...mapState({
      submital: state => state.configurator.submital,
      configurable: state => state.configurator.configurable,
      lastLockToggledAt: state => state.configurator.lastLockToggledAt
    }),
    ...mapGetters(['configurableTypeUrlString', 'isSupervisor']),
    locked () {
      return Boolean(this.submital.locked_at)
    },
    auditEventsUrl () {
      return `/api/production/submitals/${this.id}/audit_events`
    }
  },
  watch: {
    lastLockToggledAt () {
      this.$refs.auditTable?.fetchEvents()
    }
  },
  mounted () {
    if (!this.submital.id || this.submital.id !== this.id) {
      this.fetchSubmital()
    }
  },
  methods: {
    fetchSubmital () {
      this.$http.get(`/api/production/submitals/${this.id}`)
        .then((res) => {
          const { configurable, _quotes, ...submital } = res.data
          this.$store.commit('setConfigurable', configurable)
          this.$store.commit('setSubmital', submital)
        })
        .catch(() => {
          this.$store.commit('setConfigurable', {})
          this.$store.commit('setSubmital', {})
        })
    },
    deleteSubmital () {
      if (this.processing) return

      this.processing = true
      this.$http.delete(`/api/production/submitals/${this.id}`)
        .then(() => {
          this.showConfirmModal = false
          this.$router.push(`/app/prod/proyectos/${this.submital.project_id}`)
        })
        .catch(e => console.log(e))
        .finally(() => { this.processing = false })
    }
  }
}
</script>

<style scoped>
.admin-wrapper {
  margin: 0 auto;
}
</style>